export const lang = {
  语言: "中文",
  登录: "Login",
  微信登录: "WeChat",
  账户登录: "Account",
  请使用微信扫描二维码登录: "Please use WeChat to scan the QR code to log in",
  公司版权所有北京路晨伟业仪器设备有限公司: "Company copyright: Beijing Sumj Instrument Equipment Co., Ltd",
  京ICP备18062262号1: " ICP:18062262-1",
  设备数据: "Device data",
  首页: "Home",
  手动单通道: "Manual single channel",
  自动单通道: "Automatic single channel",
  手动双通道: "Manual dual channel",
  自动双通道: "Automatic dual channel",
  单通道带剪切力: "Manual single channel with shear force",
  静力触探: "Static penetration",
  修改密码: "Change the password",
  退出: "quit",
  旧密码: "Old password",
  新密码: "New password",
  确认新密码: "Confirm the new password",
  保存: "Save",
  取消: "Canel",
  密码至少为6位: "The password must be at least 6 digits",
  密码错误: "The password is incorrect",
  微信用户: "WeChat users",
  确定要退出吗: "Are you sure you want to quit?",
  新增绑定设备: "Added bound devices",
  设备序列号: "Serial Number",
  经销商电话: "Dealer Phone",
  备注: "Remark",
  绑定: "Bind",
  重置: "Reset",
  序列号: "Serial Number",
  已绑定设备: "The device is bound",
  设备类型: "Device type",
  绑定时间: "Bind time",
  操作: "Operate",
  解绑: "Unbind",
  请输入序列号: "Please enter the serial number",
  请输入经销商电话: "Please enter your dealer number",
  请输入备注: "Please enter a comment",
  确定要解绑吗: "Are you sure you want to untie?",
  由斯姆捷科技有限公司提供技术支持: "Technical support prompted by Sumj Technology Co., Ltd",
  日期: "Date",
  孔号: "Num.",
  试验时间: "Test time",
  截面积: "C.Area",
  表面积: "S.Area",
  位移点长度: "Length",
  起始深度: "Depth",
  打印: "Print",
  导出: "Exp",
  删除: "Del",
  图形: "graphics",
  详细信息: "detail",
  深度: "depth",
  阻力: "resistance",
  锥尖阻力: "Cone tip resistance",
  确定要删除吗: "Are you sure you want to delete it?",
  深度压强: "Depth/pressure",
  压强: "pressure",
  全屏: "View in full screen",
  打印图表: "Print chart",
  导出JPEG: "Download JPEG image",
  导出PDF: "Download PDF document",
  导出PNG: "Download PNG image",
  导出SVG: "Download SVG vector image",
  试验编号: "Num.",
  侧壁阻力: "Sidewall resistance",
  深度锥尖阻力: "Depth/cone tip resistance",
  深度侧壁阻力: "Depth/sidewall resistance",
  土类型: "Soil type",
  工程编号: "Project number",
  试验深度: "Depth",
  运行系数: "Operating coefficient",
  孔口高度: "Height",
  地下水位: "level",
  角度: "angle",
  抗剪强度: "Shear strength",
  存在空数据: "There is empty data",
  请选择一条原状土和一条重塑土记录: "Please select a piece of unaltered soil and a record of reshaped soil",
  角度抗剪强度: "Angle/shear strength",
  修改成功: "Save successfully",
  密码不一致: "The passwords are inconsistent",
  修改失败: "Modification failed",
  请求失败: "The request failed!",
  请输入账号: "Please enter the account number",
  请输入密码: "Please enter a password",
  重塑土: "Remolded soil",
  原状土: "Undisturbed soil",
  测缝仪: "Sum tester",
  测缝仪数据查询: "Sum tester data query",
  构件: "component",
  最大缝宽: "Max width",
  最小缝宽: "Min width",
  平均缝宽: "Avg width",
  加载中: "loading",
  测点: "point",
  缝宽: "width",
  工程管理: "project management",
  增加: "Add",
  编辑: "Edit",
  测位管理: "Position management",
  测点管理: "Measurement point management",
  无数据: "No Data",
  工程信息: "Engineering information",
  工程名称: "Project name",
  开始时间: "Start time",
  结束时间: "End time",
  测位信息: "Position measurement information",
  测位名称: "Side name",
  测点信息: "Measurement point information",
  测点名称: "Side point name",
  请输入测点名称: "Please enter a name for the measurement point",
  请选择设备: "Please select a device",
  设备通道: "Device channel",
  请选择通道: "Please select a channel",
  请输入工程名称: "Please enter a project name",
  请输入开始日期: "Please enter a start date",
  请输入结束日期: "Please enter an end date",
  请输入测位名称: "Please enter a side name",
  测点设备: "Measuring point equipment",
  测点通道: "Measurement point channel",
  表层: "surface",
  中: "middle",
  中上: "Upper",
  中下: "Lower",
  底层: "underlying",
  环境: "environment",
  请选择项目: "Please select a project",
  删除成功: "The deletion was successful",
  保存成功: "Save successfully",
  请选择测位: "Please select a position",
  开始日期: "Start date",
  结束日期: "End date",
  公司名称: "Company name",
  修改公司名称: "Modify the company name",
  请选择测点: "Please select a measurement point",
  选择日期: "Select a date",
  我的工程: "My project",
  测位列表: "List of positions",
  请选择工程: "Please select a project",
  请至工程管理增加测位: "Please go to Project Management to add sideways",
  导出峰值数据: "Export data",
  原始数据导出见我的设备: "The raw data is exported to My Device",
  该测位下无测点: "There are no measurement points under this lateral position",
  通道: "Channel",
  最新温度: "Latest temperature",
  返回时间: "Acquisition time",
  峰值: "Peak",
  峰值时间: "Peak time",
  谷值: "Valley",
  谷值时间: "Trough time",
  平均值: "average value",
  测点无数据: "There is no data at the measurement point",
  项目起止: "Project start and end",
  请选择日期: "Please select a date",
  温度: "temperature",
  时间: "Time",
  温度曲线图: "Temperature graph",
  温差报警: "Temperature difference alarm",
  上下限报警: "Upper and lower limit alarms",
  每天降温报警: "Daily cooling alarm",
  每四小时降温报警: "Cooling alarm every four hours",
  温差名称: "Temperature difference name",
  设置差值: "Set the difference",
  通道1: "Channel 1",
  通道1时间: "Channel 1 time",
  通道1温度: "Channel 1 temperature",
  通道2: "Channel 2",
  通道2时间: "Channel 2 time",
  通道2温度: "Channel 2 temperature",
  上下限名称: "Upper and lower limit names",
  通道时间: "Channel time",
  通道温度: "Channel temperature",
  上限值: "Upper limit value",
  下限值: "Lower limit value",
  时间间隔: "Time interval",
  平均温度: "Average temperature",
  降温速率报警与最大温度: "Cooling rate alarm with maximum temperature",
  选择设备: "Select the device",
  每天降温: "Cool down daily",
  每四小时降温: "Cool down every four hours",
  T1最大温度: "T1 maximum temperature",
  T2最大温度: "T2 maximum temperature",
  T3最大温度: "T3 maximum temperature",
  T4最大温度: "T4 maximum temperature",
  T5最大温度: "T5 maximum temperature",
  T6最大温度: "T6 maximum temperature",
  T7最大温度: "T7 maximum temperature",
  T8最大温度: "T8 maximum temperature",
  水泵绑定: "Water pump binding",
  报警间隔: "Alarm interval",
  差值: "Difference",
  分钟: "Minute",
  名称: "Name",
  开关: "Switch",
  请输入开关imei: "Please enter the switch IMEI",
  继电器1: "Relay 1",
  继电器2: "Relay 2",
  继电器3: "Relay 3",
  继电器4: "Relay 4",
  开关明细: "Switch details",
  关闭: "Close",
  请输入温差名称: "Please enter the temperature difference name",
  请选择工程名称: "Please select a project name",
  请输入报警间隔: "Please enter the alarm interval",
  报警间隔必须为数字值: "The alarm interval must be a numeric value",
  请输入差值: "Please enter the difference",
  请输入上下限名称: "Please enter upper and lower limit names",
  创建时间: "Creation time",
  请输入名称: "Please enter a name",
  长度15个字符: "Length: 15 characters",
  请选择继电器: "Please select a relay",
  开关imei: "Switch IMEI",
  继电器: "Relays",
  明细: "Details",
  请选择一条记录: "Please select a record",
  电池电量: "Battery level",
  无记录: "No records",
  刷新: "Refresh",
  天: "Day",
  未配置工程信息: "No project information is configured",
  工程: "Project",
  测位: "Position",
  数字格式不正确: "The number format is incorrect",
  时间格式不正确: "The time format is incorrect",
  至: "to",
  小时: "Hour",
  无线测温仪: "Thermometer",
  报警管理: "Alarm management",
  我的设备: "My Device",
  平均温度查询: "Average temperature",
  报警记录查询: "Query alarm records",
  公司名称不能为空: "The company name cannot be empty",
  二维码: "QR",
  工程地址: "Address",
  请输入工程地址: "Please enter the address of the project",
  测点绑定: "point binding",
  传感器序列号: "Sensor number",
  不能为空: "It can't be empty",
  确定要覆盖吗: "Are you sure you want to cover?",
  已绑定: "Bind",
  请选择: "Please select",
  多次: "many",
  是: "Yes",
  否: "No",
  其他人绑定中: "Others are being bound",
  降温速率报警: "Cooling rate alarm",
  前一天: "Before",
  后一天: "After",
  报警记录: "Alarm logging",
  编辑名称: "Edit the name",
  查看数据: "Review the data",
  解除绑定: "Unbind",
  原始数据: "raw Data",
  计算结果: "Calculation results",
  标定点: "Calibration points",
  电势: "potential",
  计算: "calc",
  空: "empty",
  请输入温度: "Please enter a temperature",
  电阻率: "Resistivity",
  电阻率数据查询: "Resistivity data query",

  //测温仪开始修改
  WIFI打印: "WIFIPrint",
  USB打印: "USBPrint",
  A4打印: "A4Print",
  检测道路: "road",
  检测路段: "Sections",
  检测班组: "Group",
  检测员: "Inspectors",
  坐标: "coordinate",
  道路号: "road Num",
  路幅号: "Roadway",
  里程号: "Mileage",
  起始桩号: "station",
  极限差值: "difference",
  百米清零: "cleared",
  上传: "Upload",
  正向累计值: "Positive cumulative value",
  负向累计值: "Negative cumulative value",
  正超差值: "Positive out-of-difference",
  负超差值: "Negative out-of-difference",
  平均速度: "Average",
  累计面积: "Cumulative area",
  平整度: "Flatness",
  测试点: "Test points",
  位移: "displacement",
  无地址信息: "No address information",
  打印机序列号: "Printer serial number",
  请输入打印机序列号: "Please enter the printer serial number",
  确定要上传吗: "Are you sure you want to upload?",
  数据上传中: "Data is being uploaded",
  上传成功: "The upload is successful",
  型8平整度数据查询: "Type 8 flatness data query",
  型7平整度数据查询: "Type 7 flatness data query",
  次: "times",
  请选中行: "Please select the rows",
  超差值: "Excess value",
  打印选项: "Print options",
  正在发送打印命令: "Sending print command",
  发送打印命令成功: "The send print command succeeded",
  请配置公司名称: "Please configure a company name",
  测试长度: "Length",
  试验方法: "Test Method",
  检测对象: "Detect the object",
  试验类型: "The type of trial",
  电位法: "Potentiometric method",
  电位滴定法: "Potentiometric titration",
  水泥: "cement",
  外加剂: "Admixtures",
  空白: "blank",
  硝酸银: "silver nitrate",
  氯化物: "chloride",
  拌合物: "Mixture",
  水灰比: "Water-cement ratio",
  质量体积: "Mass volume",
  上一页: "Prev",
  下一页: "Next",
  运行时长: "Running time",
  空白试验结果: "Blank test results",
  曲线1: "Curve 1",
  曲线2: "Curve 2",
  体积: "Volume",
  硝酸银试验结果: "Silver nitrate test results",
  硝酸银试验结果1: "Silver nitrate test results 1",
  硝酸银试验结果2: "Silver nitrate test results 2",
  标准液体积: "Standard liquid volume",
  标准液浓度: "Standard liquid concentration",
  硝酸银浓度: "Silver nitrate concentration",
  空白试验结果1: "Blank test result 1",
  空白试验结果2: "Blank test result 2",
  氯化物试验结果1: "Chloride test result 1",
  氯化物试验结果2: "Chloride test result 2",
  氯化物试验结果: "Chloride test result",
  氯化物质量: "Chloride mass",
  质量百分比: "Mass percentage",
  氯离子: "Chloride ion",
  氯离子数据查询: "Chloride ion data query",
  氯离子计算工具: "Chloride ion calculation tool",
  查看: "View",
  我的测点: "My measurement point",
  请至少选择一条数据: "Please select at least one piece of data",
  软化点: "Softening point",
  软化点数据查询: "Softening point data query",
  小球: "Ball",
  导入数据: "Import Data",
  编辑记录: "Edit record",
  每分钟数据: "Data per minute",
  必须输入数字以逗号隔开: "Must enter numbers separated by commas",
  请输入试验编号: "Please enter the test number",
  请输入时间: "Please enter the time",
  版本: "Version",
  截图1: "Screenshot 1",
  截图2: "Screenshot 2",
  无图片: "No picture",
  针入度: "Penetration",
  针入度数据查询: "Penetration data query",
  导出2: "Export2",
  请选中一行: "Please select a row",
  //侯棒棒
  传感器: "sensor",
  传感器1: "Sensor 1",
  传感器2: "Sensor 2",
  传感器温度: "Sensor temperature",
  传感器1温度: "Sensor 1 temperature",
  传感器2温度: "Sensor 2 temperature",
  传感器时间: "Sensor time",
  传感器1时间: "Sensor 1 time",
  传感器2时间: "Sensor 2 time",
  全部标为已读: "Mark all as read",
  上限值必须为数字值: "The upper limit value must be a numerical value",
  下限值必须为数字值: "The lower limit value must be a numerical value",
  请输入上限值: "Please enter the upper limit value",
  请输入下限值: "Please enter the lower limit value",
  背光时长: "Backlight duration",
  采样间隔: "Sampling interval",
  是否开机升级: "Whether to start up and upgrade",
  请输入背光时长: "Please enter the backlight duration",
  请输入采样间隔: "Please enter the sampling interval",
  保存失败: "Save failure",
  必须为数字值: "Must be a numerical value",
  密码为四位数字: "The password is four digits",
  必须为整数: "Must be an integer",
  对接公司名称: "Docking company name",
  t1序列号: "t1_SensorNumber",
  t2序列号: "t2_SensorNumber",
  t3序列号: "t3_SensorNumber",
  t4序列号: "t4_SensorNumber",
  t5序列号: "t5_SensorNumber",
  t6序列号: "t6_SensorNumber",
  t7序列号: "t7_SensorNumber",
  t8序列号: "t8_SensorNumber",
};
